import { FC } from "react";

import { css } from "@emotion/react";
import { Box, Typography } from "@mui/material";

export const MockPageStickyHeader: FC = () => (
  <Box
    css={css({
      width: "100%",
      justifyContent: "center",
      display: "flex",
      marginTop: "1em",
      marginBottom: "1em",
      gap: "2em",
    })}
    data-testid="mock-page-sticky-header"
  >
    <Typography variant="body1">A story about some finance stuff</Typography>
    <Typography variant="body2">A vague subtitle</Typography>
  </Box>
);
